import {
    searchTypes,
    SortTypeMapping
} from 'ugc/components/workPage/SettingPreviews/defaultGameSetting';
const UPDATE_FLAGS = 'flagsUgc/UPDATE_FLAGS';

export const searchTabType = -1;
export const ALL_TASK_UUID = '_all';

export const apiSortingTypes = {
    [SortTypeMapping.RANDOM]: 'random',
    [SortTypeMapping.RANK]: 'votes',
    [SortTypeMapping.TIME]: 'createdAt'
};

export const apiOrderTypes = {
    [SortTypeMapping.RANK]: 'desc',
    [SortTypeMapping.TIME]: 'desc'
};

export const apiSearchTypes = {
    [searchTypes.AUTHOR_NAME]: 'author',
    [searchTypes.PORTFOLIO_NAME]: 'title'
};

const defaultState = {
    searchTypeOptions: [],
    searchType: searchTypes.NO_SEARCH,
    searchKeyword: '',
    sortingType: SortTypeMapping.TIME,
    noSearchItems: false,
    taskUUID: ALL_TASK_UUID,
    selectedSectionId: ''
};

const reducer = (state = defaultState, action) => {
    switch (action.type) {
        case UPDATE_FLAGS:
            return { ...state, ...action.payload };
        default:
            return state;
    }
};

export default reducer;

export function setSearchType(searchType) {
    return {
        type: UPDATE_FLAGS,
        payload: {
            searchType
        }
    };
}

export function setSearchKeyword(searchKeyword) {
    return {
        type: UPDATE_FLAGS,
        payload: {
            searchKeyword
        }
    };
}

export function setSortingType(sortingType) {
    return {
        type: UPDATE_FLAGS,
        payload: {
            sortingType
        }
    };
}

export function setNoSearchItems(status) {
    return {
        type: UPDATE_FLAGS,
        payload: {
            noSearchItems: status
        }
    };
}

export function setTaskUUID(taskUUID) {
    return {
        type: UPDATE_FLAGS,
        payload: {
            taskUUID
        }
    };
}
